import React, { Component } from 'react';

class Answer extends Component {
    getClassName = () => {
        if(!this.props.answered) {
            return 'is-active';
        }
        return '';
    }

    render() {
        return (
            <button type="button" 
            className={`quiz__button quiz__button--answer ${this.getClassName()}`}
            data-key={this.props.id}
            data-points={this.props.answer.points}
            onClick={this.props.onClick}>
                {this.props.answer.text}
            </button>
          );
    }
  }

  export default Answer;


// WEBPACK FOOTER //
// ./src/components/Answer.js